'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DataTableControls: ()=>DataTableControls
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_use_debounce_namespaceObject = require("use-debounce");
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_FilterChip_index_cjs_namespaceObject = require("../FilterChip/index.cjs");
const external_InputText_index_cjs_namespaceObject = require("../InputText/index.cjs");
const external_Label_index_cjs_namespaceObject = require("../Label/index.cjs");
const external_PlainA_index_cjs_namespaceObject = require("../PlainA/index.cjs");
const external_DataTable_variants_cjs_namespaceObject = require("./DataTable.variants.cjs");
const DataTableFilterMenu = ({ value, menuItems, handleItemClick })=>{
    const isItemSelected = (0, external_react_namespaceObject.useCallback)((itemValue)=>value?.includes(itemValue) || false, [
        value
    ]);
    const handleItemClickInternal = (0, external_react_namespaceObject.useCallback)((itemValue)=>{
        handleItemClick(itemValue);
    }, [
        handleItemClick
    ]);
    const handleKeyDown = (0, external_react_namespaceObject.useCallback)((e)=>{
        if ('ArrowDown' === e.key) {
            e.preventDefault();
            const nextElement = e.currentTarget.nextElementSibling;
            nextElement?.focus();
        } else if ('ArrowUp' === e.key) {
            e.preventDefault();
            const prevElement = e.currentTarget.previousElementSibling;
            prevElement?.focus();
        }
    }, []);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: "no-scrollbar max-h-[calc(40vh-8px)] overflow-y-auto p-1",
        role: "listbox",
        children: menuItems.map((item)=>{
            const isSelected = isItemSelected(item.value);
            const styles = (0, external_DataTable_variants_cjs_namespaceObject.filterMenuVariants)({
                itemSelected: isSelected
            });
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("button", {
                type: "button",
                className: styles.popupItem(),
                onClick: ()=>handleItemClickInternal(item.value),
                onKeyDown: handleKeyDown,
                role: "option",
                "aria-selected": isSelected,
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: styles.itemLabelWrapper(),
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Label_index_cjs_namespaceObject.Label, {
                            className: styles.itemLabel(),
                            children: item.label
                        })
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: styles.itemSelectedIconWrapper(),
                        children: isSelected && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                            iconName: "check",
                            palette: "primary",
                            size: "20",
                            shade: "8"
                        })
                    })
                ]
            }, item.value);
        })
    });
};
const DataTableControls = ({ table, hasColumnFilters })=>{
    const [globalFilter, setGlobalFilter] = (0, external_react_namespaceObject.useState)('');
    const [debounceValue] = (0, external_use_debounce_namespaceObject.useDebounce)(globalFilter, 500);
    const [activeFilterColumnId, setActiveFilterColumnId] = (0, external_react_namespaceObject.useState)(null);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (table.options.enableGlobalFilter) table.setGlobalFilter(debounceValue);
    }, [
        debounceValue,
        table
    ]);
    const handleClearFilter = (0, external_react_namespaceObject.useCallback)(()=>{
        setGlobalFilter('');
        table.resetColumnFilters();
    }, [
        setGlobalFilter,
        table
    ]);
    const getColumnMenuItems = (0, external_react_namespaceObject.useCallback)((column)=>{
        if (column.columnDef.meta?.filter?.options) return column.columnDef.meta?.filter?.options;
        const uniqueValues = [
            ...new Set(table.getPreFilteredRowModel().rows.map((row)=>row.getValue(column.id)).filter((value)=>null != value).map(String))
        ];
        return uniqueValues.toSorted((a, b)=>a.localeCompare(b)).map((value)=>({
                label: value,
                value
            }));
    }, [
        table
    ]);
    const handleColumnFilterChange = (0, external_react_namespaceObject.useCallback)((columnId, itemValue)=>{
        const column = table.getColumn(columnId);
        if (!column) return;
        const currentFilter = column.getFilterValue() || [];
        const newFilter = currentFilter.includes(itemValue) ? currentFilter.filter((value)=>value !== itemValue) : [
            ...currentFilter,
            itemValue
        ];
        column.setFilterValue(newFilter.length > 0 ? newFilter : void 0);
    }, [
        table
    ]);
    const getHandleItemClick = (0, external_react_namespaceObject.useCallback)((columnId)=>(itemValue)=>handleColumnFilterChange(columnId, itemValue), [
        handleColumnFilterChange
    ]);
    const handleFilterChipSelectionChange = (0, external_react_namespaceObject.useCallback)((columnId)=>()=>{
            setActiveFilterColumnId(columnId);
        }, []);
    const getFilterCount = (0, external_react_namespaceObject.useCallback)((column)=>{
        const filterValue = column.getFilterValue();
        const length = filterValue?.length;
        return length && length > 1 ? length : void 0;
    }, []);
    const handleOpenChange = (0, external_react_namespaceObject.useCallback)(()=>(open)=>{
            if (!open) setActiveFilterColumnId(null);
        }, []);
    const getColumnHeaderText = (0, external_react_namespaceObject.useCallback)((column)=>{
        const { header } = column.columnDef;
        const filterLabel = column.columnDef.meta?.filter?.label;
        if (filterLabel) return filterLabel;
        if (header && 'function' != typeof header) return header;
        return column.id;
    }, []);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: "flex flex-wrap items-center gap-2 pb-7",
        children: [
            hasColumnFilters && table.getAllColumns().map((column)=>column.getCanFilter() && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_FilterChip_index_cjs_namespaceObject.FilterChip, {
                    id: `${column.id}-filter-chip`,
                    label: getColumnHeaderText(column),
                    selected: !!column.getFilterValue(),
                    count: getFilterCount(column),
                    onSelectionChange: handleFilterChipSelectionChange(column.id),
                    opens: true,
                    openOnHover: false,
                    open: activeFilterColumnId === column.id,
                    onOpenChange: handleOpenChange(),
                    slotClassNames: {
                        positionerClass: 'z-3',
                        popupClass: 'bg-primary-1 shadow-overlay-md !max-h-[40vh] rounded-xl p-[4px] outline-none flex !w-auto'
                    },
                    align: 'start',
                    hideCloseButton: true,
                    classNames: {
                        bodySlot: 'pt-2'
                    },
                    showCloseButton: false,
                    showArrow: false,
                    positionerOffset: 4,
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(DataTableFilterMenu, {
                        value: column.getFilterValue() || [],
                        menuItems: getColumnMenuItems(column),
                        handleItemClick: getHandleItemClick(column.id)
                    })
                }, `${column.id}-filter-chip`)),
            table.options.enableGlobalFilter && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_InputText_index_cjs_namespaceObject.InputText, {
                placeholder: "Search",
                iconLeft: "search",
                size: "sm",
                className: "w-75",
                value: globalFilter,
                onChange: (e)=>{
                    const value = e.target.value;
                    setGlobalFilter(value);
                }
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_PlainA_index_cjs_namespaceObject.PlainA, {
                type: "primary",
                textStyle: "body2",
                onClick: handleClearFilter,
                className: "whitespace-nowrap",
                tabIndex: 0,
                children: "Clear Filters"
            })
        ]
    });
};
exports.DataTableControls = __webpack_exports__.DataTableControls;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DataTableControls"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
